import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { useRootStore } from '../../App';
import { InquiryListNotFound } from '../molecules/InquiryListNotFound';
import { InquiryListItem } from './InquiryListItem';
import InfiniteScroll from 'react-infinite-scroller';
import { Loader } from '../atoms';

const MainStyledDiv = styled.div`
  font-size: 12px !important;
  line-height: 18px;
  margin-top: 4px !important;
  text-align: center;
`;

const StyledDivTable = styled.div`
  display: table;
  border-bottom: solid 1px #ebebeb !important;
  color: #333333;
  border-collapse: separate;
  border-spacing: 0;
  vertical-align: bottom;
  width: 918px;
  margin: 0;
  padding: 0;
  font-style: normal;
  font-size: 13px;
`;

const StyledUl = styled.ul`
  list-style: none outside none;
  margin: 0px;
  padding: 0px;
`;

const StyledDivTableRowGroup = styled.div`
  display: table-row-group;
  color: #333333;
  border-bottom: solid 1px #c0c0c0 !important;
  border-collapse: separate !important;
  border-spacing: 0 !important;
  vertical-align: bottom;
  width: 918px;
`;

const StyledDiv = styled.div``;

export const InquiryList = observer(() => {
  const root = useRootStore();
  const { isWide } = root.layoutStore;
  const {
    filteredInquiries,
    totalCount,
    loadedInquiryNumber,
    hasMoreInquiry,
    loadMore,
  } = root.inquiryStore;

  console.log({ totalCount });

  if (totalCount < 0) {
    return <Loader />;
  }

  return isWide ? (
    <StyledDivTable>
      <StyledDivTableRowGroup>
        {totalCount === 0 ? (
          <InquiryListNotFound isWide={isWide} />
        ) : (
          <InfiniteScroll
            loadMore={loadMore} // callback function. it is called when InfiniteScroll judges it needs more data to fill screen
            hasMore={hasMoreInquiry} // when true, loader JSX is displayed
            loader={
              <MainStyledDiv key={0}>
                さらに以前の問い合わせを取得中 ...
              </MainStyledDiv>
            }
          >
            {/* because the data is already fully-fetched and no need to fetching piece by piece,
                this 'slice' is temporary to incrementally display by scroll. */}
            {filteredInquiries
              .slice(0, loadedInquiryNumber)
              .map((inquiry, index) => {
                return (
                  <InquiryListItem
                    key={`inquiry-list-${inquiry.inquiryId}`}
                    className={`inquiry-list-${index}`}
                    inquiry={inquiry}
                  />
                );
              })}
          </InfiniteScroll>
        )}
      </StyledDivTableRowGroup>
    </StyledDivTable>
  ) : (
    <StyledUl>
      <StyledDiv>
        {totalCount === 0 ? (
          <InquiryListNotFound isWide={isWide} />
        ) : (
          <InfiniteScroll
            loadMore={loadMore} // callback function. it is called when InfiniteScroll judges it needs more data to fill screen
            hasMore={hasMoreInquiry} // when true, loader JSX is displayed
            loader={
              <MainStyledDiv key={0}>
                さらに以前の問い合わせを取得中 ...
              </MainStyledDiv>
            }
          >
            {/* because the data is already fully-fetched and no need to fetching piece by piece,
                this 'slice' is temporary to incrementally display by scroll. */}
            {filteredInquiries
              .slice(0, loadedInquiryNumber)
              .map((inquiry, index) => {
                return (
                  <InquiryListItem
                    key={`inquiry-list-${inquiry.inquiryId}`}
                    className={`inquiry-list-${index}`}
                    inquiry={inquiry}
                  />
                );
              })}
          </InfiniteScroll>
        )}
      </StyledDiv>
    </StyledUl>
  );
});
